import { makeStyles } from '@material-ui/core/styles';
import theme from '../../theme/booking-theme';

const useStyles = makeStyles(() => ({
  paper: {
    '& .MuiPaper-root': {
      marginRight: 0,
      marginLeft: 0,
    },
  },
  MuiDialogContentRoot: {
    padding: '0 !important',
    minWidth: 310,
    minHeight: 539,

    [theme.breakpoints.up('md')]: {
      minWidth: 508,
    },

    [theme.breakpoints.up('lg')]: {
      minWidth: 680,
    },
  },
}));

export default useStyles;
